import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import UTC from 'dayjs/plugin/utc'
import Timezone from 'dayjs/plugin/timezone'

dayjs.extend(LocalizedFormat)
dayjs.extend(UTC)
dayjs.extend(Timezone)

type Props = {
  children: string | number
  format?: string
}

// https://day.js.org/docs/en/display/format#list-of-localized-formats
export const formatTime = (
  time: string | number | Date,
  format = 'L',
  timezone?: string
) => {
  if (timezone) return dayjs(time).tz(timezone).format(format)
  return dayjs(time).format(format)
}

export const guessTimezone = () => dayjs.tz.guess()

export const Time = ({ children, format = 'L' }: Props) => {
  return <>{formatTime(children, format)}</>
}
